module.exports = __webpack_public_path__ + "static/img/ver-2.eb163498.png";